
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { APP_PRICING_URL, APP_SIGN_IN_URL } from "@/lib/appUrls";

interface MobileNavProps {
  isOpen: boolean;
  scrollToSection: (id: string) => void;
  onClose: () => void;
}

const MobileNav = ({ isOpen, scrollToSection, onClose }: MobileNavProps) => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState<string | null>(null);
  const isHomePage = location.pathname === "/";
  
  // Reset active section when changing pages
  useEffect(() => {
    setActiveSection(null);
  }, [location.pathname]);
  
  if (!isOpen) return null;

  const handleSectionClick = (section: string) => {
    setActiveSection(section);
    scrollToSection(section);
    onClose();
  };

  return (
    <div className="md:hidden fixed inset-x-0 top-20 bg-gray-900 border-b border-gray-800 shadow-lg">
      <div className="px-4 py-6 space-y-5">
        <div className="space-y-3">
          {isHomePage ? (
            <>
              <button
                onClick={() => handleSectionClick("hero")}
                className={`relative w-full text-left px-4 py-2 rounded-lg transition-all duration-200 ${
                  activeSection === "hero" || (!activeSection && isHomePage)
                    ? "text-white bg-primary/20" 
                    : "text-gray-300 hover:text-white hover:bg-gray-800"
                }`}
              >
                Home
              </button>
            </>
          ) : (
            <>
              <Link
                to="/"
                className="relative block px-4 py-2 rounded-lg text-gray-300 hover:text-white hover:bg-gray-800 transition-colors"
                onClick={onClose}
              >
                Home
              </Link>
            </>
          )}
          <a
            href={APP_PRICING_URL}
            className="relative block px-4 py-2 rounded-lg transition-all duration-200 text-gray-300 hover:text-white hover:bg-gray-800"
            onClick={onClose}
          >
            Pricing
          </a>
          <Link
            to="/blog"
            className={`relative block px-4 py-2 rounded-lg transition-all duration-200 ${
              location.pathname === "/blog" 
                ? "text-white bg-primary/20" 
                : "text-gray-300 hover:text-white hover:bg-gray-800"
            }`}
            onClick={onClose}
          >
            Blog
          </Link>
        </div>
        <div className="pt-4 border-t border-gray-800">
          <a
            href={APP_SIGN_IN_URL}
            className={cn(
              "flex items-center justify-center gap-2 w-full",
              "px-6 py-2.5 rounded-lg",
              "text-white font-bold border-2 border-white/30 bg-white/5",
              "hover:bg-white/10 hover:border-white/50 transition-all duration-300"
            )}
            onClick={onClose}
          >
            <LogIn size={18} />
            <span>Sign In</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
